/**
 * Grid utilities for snapping node positions and dimensions to a grid
 */

// Grid size in pixels - kept at 4px for handle alignment
export const GRID_SIZE = 4;

/**
 * Snaps a value to the nearest grid point
 * @param value The value to snap
 * @returns The snapped value
 */
export function snapToGrid(value: number): number {
  // Return the original value without snapping to disable grid snapping
  return value;
}

/**
 * Snaps a position object to the grid
 * @param position The position object with x and y coordinates
 * @returns A new position object with coordinates snapped to the grid
 */
export function snapPositionToGrid(position: { x: number; y: number }): { x: number; y: number } {
  // Return the original position without snapping to disable grid snapping
  return {
    x: position.x,
    y: position.y,
  };
}

/**
 * Snaps dimensions (width, height) to the grid
 * @param dimensions The dimensions object with width and height
 * @returns A new dimensions object with values snapped to the grid
 */
export function snapDimensionsToGrid(dimensions: { width?: number; height?: number }): { width: number; height: number } {
  // Ensure we have default values if dimensions are undefined
  const width = dimensions.width ?? 0;
  const height = dimensions.height ?? 0;
  
  // Return the original dimensions without snapping to disable grid snapping
  return {
    width: width,
    height: height
  };
}
